import React, { useMemo, type FC } from 'react'
import { useIntl } from 'react-intl'
import { useAtom } from 'jotai'
import { FormElement, Select, GridCell, InputText } from 'mailup-web-components'
import { filterFormImmerAtom } from '../../state/state'
import { type ConditionProps } from '../../types'
import { type TextMatch } from '../../../../types/FilterCondition'
import { textMatchOpts } from '../../utils/conditionOptions'
import {
  textMatchHasMultipleValues,
  textMatchHasNoValue,
} from '../../utils/profileFieldSpecValidation'
import { type UiTextSpec } from '../../filterConditionTypes'

const TextSpecCondition: FC<ConditionProps> = ({ blockIndex, condIndex }) => {
  const intl = useIntl()
  const [filter, setFilter] = useAtom(filterFormImmerAtom)
  const condition = filter.Blocks[blockIndex].Conditions[condIndex]
  const spec = condition.Spec as UiTextSpec

  const matchOptions = useMemo(() => textMatchOpts(intl), [intl])

  const handleOperatorChange = (op: TextMatch): void => {
    setFilter((draft) => {
      const cond = draft.Blocks[blockIndex].Conditions[condIndex]
      ;(cond.Spec as UiTextSpec) = {
        ...(cond.Spec as UiTextSpec),
        Match: op,
        Value: textMatchHasNoValue(op) ? undefined : '',
      }
    })
  }

  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const valueString = e.target.value
    setFilter((draft) => {
      const cond = draft.Blocks[blockIndex].Conditions[condIndex]
      ;(cond.Spec as UiTextSpec).Value = valueString
    })
  }

  return (
    <>
      <GridCell span={3}>
        <FormElement>
          <Select
            placeholder={intl.formatMessage({
              id: 'Load.Filters.OperatorPlaceholder',
            })}
            options={matchOptions}
            value={spec.Match}
            onChange={handleOperatorChange}
            data-mu-test='input-select-operator'
          />
        </FormElement>
      </GridCell>
      {spec.Match !== undefined && !textMatchHasNoValue(spec.Match) && (
        <GridCell span={9}>
          <FormElement
            data-mu-test='filterForm-TextSpec-values_element'
            hint={
              textMatchHasMultipleValues(spec.Match)
                ? intl.formatMessage({ id: 'Load.Filters.MultipleValuesTips' })
                : undefined
            }
          >
            <InputText
              data-mu-test='filterForm-TextSpec-values_input'
              name='TextSpec-values'
              value={spec.Value}
              onChange={handleValueChange}
              placeholder={intl.formatMessage({
                id: 'Load.Filters.InsertValuePlaceholder',
              })}
            />
          </FormElement>
        </GridCell>
      )}
    </>
  )
}

export default TextSpecCondition
